<div id="education" class="page-wrapper">

  <app-menu [activeMenuIndex]="5">
  </app-menu>

  <!--<div class="subheader-bar-wrapper">
    <div class="subheader-content">
      <a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
        <div class="subheader-content-text">
          Ihr kostenfreies Testset!
        </div>
      </a>
    </div>
  </div>-->

  <div class="floating-chameleon">
  </div>

  <div class="content-icon">
    <img src="/assets/img/template/icon-education.svg" alt="Icon Bildung" />
  </div>

  <div class="title-wrapper">

    <h1>
      Education
    </h1>
		<h2 class="m-b-40">
			Morbus Fabry im Blick: <br>
      Aktuelles aus der Literatur
		</h2>
		<div class="title-description">
			Neue Erkenntnisse und spannende Forschungsergebnisse zu Morbus Fabry finden Sie in unserem Newsletter kurz und knapp zusammengestellt. Sie finden unter anderem folgende Themen:
		</div>
  </div>

  <div class="info-section m-t-0 m-b-10">
    <div class="wrapper-half-title-center">
      <div class="separator education"></div>
      <div class="info-section-title">
        Ein EKG-basierter Score beurteilt die Wahrscheinlichkeit einer kardialen Beteiligung bei M. Fabry
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        In der kardialen Magnetresonanztomographie (cMRT) gelten niedrige myokardiale T1-Relaxationszeiten als Surrogatparameter für eine Glykosphingolipid-Speicherung in Myokardzellen. In der Untersuchung von Figliozzi et al., 2021 an 119 Fabry-Patienten und 26 gesunden Kontrollpersonen waren im EKG vier Parameter mit niedrigen T1-Werten im cMRT assoziiert: Sokolow-Lyon-Index, Verhältnis von P-Welle zu PR-Segment-Dauer, QRS-Zeit und QT-Zeit
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-10">
    <div class="wrapper-half-title-center">
      <div class="separator education"></div>
      <div class="info-section-title">
        Screening von Patienten mit chronischen Nierenerkrankungen in Japan auf M. Fabry
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        Die Prävalenz von M. Fabry bei Dialyse-Patienten wird in der Literatur mit 0–1,69% angegeben. In der Kohortenstudie von Nagata et al., 2021 wies von den 1.703 untersuchten dialysepflichtigen Patienten einer einen M. Fabry auf (Prävalenz 0,06%) auf. In der Kohorte der 419 Patienten mit CKD des Stadiums 1-5 wurden 2 Fabry-Patienten gefunden (Prävalenz 0,48%).
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-10">
    <div class="wrapper-half-title-center">
      <div class="separator education"></div>
      <div class="info-section-title">
        Ionenkanäle und Schmerz bei M. Fabry
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        In dieser Übersichtsarbeit von Weissmann et al., 2021 wurde eine Vielzahl von Studien in vitro und mit Tiermodellen zum Einfluss von Ionenkanälen auf den Schmerz bei M. Fabry ausgewertet. Untersucht wurden bislang unter anderem die spannungsabhängigen Natriumkanäle NaV1,7 und NaV1,8, die Transient-Rezeptorpotenzial-Kanäle TRPV1, TRPM8 oder TRPA1, spannungsabhängige Kalziumkanäle oder verschiedene Kalziumkanäle. Nach den bisherigen Befunden unterscheidet sich der Schmerz bei M. Fabry von anderen Small-Fiber-Neuropathien.
      </p>
    </div>
  </div>

  <!--<div class="info-section info-section-1">

    <div class="info-section-subtitle info-section-subtitle-1">
      Morbus Fabry im Blick:<br>
      Aktuelles aus der Literatur
    </div>

    <div class="info-section-text info-section-text-1">
      Bleiben Sie auf dem Laufenden. Wir senden Ihnen regelmäßig kurz zusammengefasste<br>
      Forschungs- und Studienergebnisse zum Thema Morbus Fabry zu.
    </div>

    <div class="info-section-text info-section-text-italic info-section-text-2">
      Von Dr. Charlotte Nejad &amp; Dr. Martina Kralewski
    </div>

  </div>-->

<!--  <app-login zone="education">-->
  <app-login zone="2000000014820"> <!-- Development -->
<!--  <app-login zone="2000000016670"> <!-- Takeda Server -->
<!--    <app-login zone="2000000014985"> <!-- Production -->
  </app-login>

  <app-footer>
  </app-footer>

</div>
